import axios from 'axios';
import { PASS_BASE_URL } from '../config/ApiConfig';
import {showNotification } from './NotificationService';

export const getPassTypes = async () => { // Get the types of passes
  try {
    const response = await axios.get(`${PASS_BASE_URL}/GetAllPasses`);
    return response.data;
  }catch (error) {
    showNotification("Oops! Something went wrong. Please try again later.", "error");
    throw error;
  }
};